export const ISSUER_NAME = 'issuer';
export const PARENT_NAME = 'parent';
export const RATING_AGENCY_NAME = 'ratingAgency';
export const UNDERWRITER_NAME = 'underwriter';

export const restrictedExportTopCompaniesDescription = 'Exports are available on <strong>Premium</strong> and <strong>Professional</strong> plans. Upgrade your plan for access.';
